/* LEADS */
// export const GET_LEADS = "GET_LEADS"
export const GET_LEADS_SUCCESS = "GET_LEADS_SUCCESS"
export const GET_LEADS_FAIL = "GET_LEADS_FAIL"
export const GET_LEADS_ENVIADOS = "GET_LEADS_ENVIADOS"
export const CREATE_LEAD = "CREATE_LEAD"
export const CREATE_LEAD_SUCCESS = "CREATE_LEAD_SUCCESS"
export const CREATE_LEAD_FAIL = "CREATE_LEAD_FAIL"
export const UPDATE_LEAD = "UPDATE_LEAD"
export const UPDATE_LEAD_SUCCESS = "UPDATE_LEAD_SUCCESS"
export const UPDATE_LEAD_FAIL = "UPDATE_LEAD_FAIL"
export const SEND_LEAD = "SEND_LEAD"
export const SEND_LEAD_SUCCESS = "SEND_LEAD_SUCCESS"
export const SEND_LEAD_FAIL = "SEND_LEAD_FAIL"

export const CLEAR_SEND_LEAD_RESULT = "CLEAR_SEND_LEAD_RESULT"
